import React, { useEffect, useState } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import exportFromJSON from "export-from-json";
import { AvForm, AvField } from "availity-reactstrap-validation";
import filterFactory, { selectFilter } from "react-bootstrap-table2-filter";
import { Row, Col, Card, CardBody, Container, Button, Label } from "reactstrap";
// Redux
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";

//Import Breadcrumb
import Breadcrumb_2Items from "../../../../components/Common/Breadcrumb_2Items";
import BootstrapTable from "react-bootstrap-table-next";
import "../../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit";

import { postSubmitForm } from "../../../../helpers/forms_helper";
import moment from "moment";

import Select from "react-select";
import makeAnimated from "react-select/animated";
import preloader from "../../../../helpers/preloader";
import showNotification from "../../../../helpers/show_notification";
import { MapObjectUnits } from "../../../../helpers/units";
import printDiv from "../../../../helpers/print_data";

const animatedComponents = makeAnimated();

const ItemwiseOrderReport = (props) => {
  const { SearchBar } = Search;
  const [dateFrom, setDateFrom] = useState();
  const [dateTo, setDateTo] = useState();
  const [selectedItem, setSelectedItem] = useState("All");

  const [allItems, setAllItems] = useState([]);
  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }
  useEffect(() => {
    const currentDay = new Date();
    const firstDay = new Date(
      currentDay.getFullYear(),
      currentDay.getMonth(),
      1,
    );
    setDateFrom(formatDate(firstDay));
    setDateTo(formatDate(currentDay));
    loadAllItems();
  }, []);

  const loadAllItems = async () => {
    let url = process.env.REACT_APP_BASEURL + "items/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      setAllItems(response.data);
    } else {
      showNotification(response.message, "Error");
    }
  };

  const [allOrders, setAllOrders] = useState([]);

  const loadOrders = async () => {
    try {
      const days_diff = moment(dateTo).diff(dateFrom, "days");
      if (days_diff > 30) {
        setFilteredOrders([]);
        showNotification(
          "Total number of days cannot be more than 31.",
          "Error",
        );
        return false;
      } else if (days_diff < 0) {
        setFilteredOrders([]);
        showNotification("Invalid date range.", "Error");
        return false;
      }
      preloader(true);
      let date_from = moment(dateFrom).format("YYYY-MM-DD"),
        date_to = moment(dateTo).format("YYYY-MM-DD");
      // console.log(date_from, date_to);
      let url =
        process.env.REACT_APP_BASEURL + "itemorders/itemwise_order_report";

      const response = await postSubmitForm(url, {
        item_id: selectedItem._id,
        date_from: date_from,
        date_to: date_to,
      });
      if (response && response.status === 1) {
        preloader(false);

        setAllOrders(response.data);
      } else {
        preloader(false);
        showNotification(response.message, "Error");
        return false;
      }
    } catch (error) {
      console.log(error);
    } finally {
      preloader(false);
    }
  };

  const [orderStatus, setOrderStatus] = useState("All");
  const [filteredOrders, setFilteredOrders] = useState([]);

  useEffect(() => {
    if (orderStatus === "All") {
      setFilteredOrders(allOrders);
    } else {
      let arr = allOrders.filter((order) => order.status === orderStatus);
      setFilteredOrders(arr);
    }
  }, [allOrders, orderStatus]);

  const columns_external = [
    {
      dataField: "_id.item_id",
      hidden: true,
    },
    {
      dataField: "_id.item_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },
    {
      dataField: "_id.branch",
      text: props.t("Branch"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
    },
    {
      dataField: "name",
      text: props.t("Item"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
    },
    {
      dataField: "category",
      text: props.t("Category"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
    },
    {
      dataField: "sub_category",
      text: props.t("Sub Category"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
    },
    {
      dataField: "brand",
      text: props.t("Brand"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
    },

    {
      dataField: "total_order",
      text: props.t("Total Order"),

      formatter: (cell, row) => {
        return MapObjectUnits(row.total_order);
      },

      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "total_deliver",
      text: props.t("Total Delivered"),

      formatter: (cell, row) => {
        return MapObjectUnits(row.total_deliver);
      },

      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "total_receive",
      text: props.t("Total Received"),

      formatter: (cell, row) => {
        return MapObjectUnits(row.total_receive);
      },

      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "receiving_cost",
      text: props.t("Receiving Cost"),
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
    },
  ];

  const handleDownload = () => {
    const fileName = "ItemwiseOrderReport";
    const exportType = "xls";

    if (filteredOrders) {
      var data = JSON.parse(JSON.stringify(filteredOrders));
      data.forEach(function (v) {
        v.total_order = MapObjectUnits(v.total_order);
        v.total_deliver = MapObjectUnits(v.total_deliver);
        v.total_receive = MapObjectUnits(v.total_receive);
        delete v._id;
        delete v.formula;
        delete v.quantity;
        delete v.available;
        delete v.unit_levels;
        delete v.total;
      });
      //console.log(data);
      exportFromJSON({ data, fileName, exportType });
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb_2Items
            alternateTitle={props.t("Item-wise Order Report")}
            title={props.t("Reports")}
            breadcrumbItem1={props.t("Orders")}
            breadcrumbItem2={props.t("Item-wise Order Report")}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm>
                    <Row>
                      <Col lg={3}>
                        <AvField
                          name="dateFrom"
                          label={props.t("From Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateFrom}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDateFrom(formatDate(selectedDate));

                            const maxDate = moment(selectedDate)
                              .add(30, "days")
                              .format("YYYY-MM-DD");
                            const currentDate = moment().format("YYYY-MM-DD");

                            if (
                              moment(dateTo).isAfter(maxDate) ||
                              moment(dateTo).isAfter(currentDate)
                            ) {
                              setDateTo(
                                maxDate > currentDate ? currentDate : maxDate,
                              );
                            }
                          }}
                          max={moment().format("YYYY-MM-DD")}
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                      <Col lg={3}>
                        <AvField
                          name="dateTo"
                          label={props.t("To Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateTo}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDateTo(formatDate(selectedDate));
                          }}
                          min={dateFrom}
                          max={
                            moment(dateFrom)
                              .add(30, "days")
                              .format("YYYY-MM-DD") >
                            moment().format("YYYY-MM-DD")
                              ? moment().format("YYYY-MM-DD")
                              : moment(dateFrom)
                                  .add(30, "days")
                                  .format("YYYY-MM-DD")
                          }
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                      <Col lg={4}>
                        <Label>{props.t("Item")}</Label>
                        <Select
                          value={selectedItem}
                          onChange={(selected) => {
                            setSelectedItem(selected);
                          }}
                          options={allItems}
                          classNamePrefix="select2-selection"
                          components={animatedComponents}
                          required
                        />
                      </Col>
                      <Col lg={2}>
                        {" "}
                        <Button
                          type="submit"
                          className="btn btn-md btn-success mt-4"
                          onClick={() => {
                            if (dateFrom && dateTo) {
                              loadOrders();
                            }
                          }}
                        >
                          <i className="mdi mdi-checkbox-marked-circle"></i>{" "}
                          {props.t("Check")}
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <Row className="mb-2">
                    <Col sm="4">
                      <Button
                        type="submit"
                        className="btn btn-sm btn-secondary"
                        onClick={handleDownload}
                      >
                        <i className="mdi mdi-file-export"></i>{" "}
                        {props.t("Export CSV")}
                      </Button>{" "}
                      {"    "}
                      <Link
                        to="#"
                        onClick={() => {
                          printDiv("printDiv");
                        }}
                        className="btn btn-sm btn-success mr-2"
                      >
                        <i className="fa fa-print"></i> Print
                      </Link>
                      <div className="search-box mr-2 mb-2 d-inline-block">
                        <div className="position-relative"></div>
                      </div>
                    </Col>
                  </Row>
                  <div className="row" id="printDiv">
                    <div className="col-md-12">
                      <ToolkitProvider
                        keyField="item_details._id"
                        data={filteredOrders && filteredOrders}
                        columns={columns_external}
                        noDataIndication={props.t("No data to display.")}
                        bootstrap4
                        search
                      >
                        {(props) => (
                          <div>
                            <Row>
                              <Col lg={4}>
                                <SearchBar
                                  {...props.searchProps}
                                  style={{ width: "300px" }}
                                />
                              </Col>
                              <Col lg={4}></Col>
                              <Col lg={4} className="text-right">
                                {/* <select
                                  name="status"
                                  className="form-control"
                                  value={orderStatus}
                                  onChange={(e) => {
                                    setOrderStatus(e.target.value);
                                  }}
                                >
                                  <option value="All">All</option>
                                  <option value="Placed">Placed</option>
                                  <option value="Approved">Approved</option>
                                  <option value="Dispatched">Dispatched</option>
                                  <option value="Partially Dispatched">
                                    Partially Dispatched
                                  </option>
                                  <option value="Closed">Closed</option>
                                </select> */}
                              </Col>
                            </Row>
                            <BootstrapTable
                              striped
                              hover
                              condensed
                              filter={filterFactory()}
                              {...props.baseProps}
                            />
                          </div>
                        )}
                      </ToolkitProvider>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => {};
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(ItemwiseOrderReport)),
);
